import { defineRule } from "vee-validate";

defineRule("required", (value) => {
  if (value) {
    return true;
  }
  return "필수 입력 값입니다.";
});
defineRule("phone", (value) => {
  const regex = /^[0-9]*$/.test(value);
  if (regex && value.length === 11) {
    return true;
  } else {
    return "휴대폰번호 11자리를 정확히 입력해주세요.";
  }
});
defineRule("phoneCertNo", (value) => {
  const regex = /^([0-9]{6})*$/.test(value);
  if (regex) {
    return true;
  } else {
    return "정확한 인증번호를 입력해주세요.";
  }
});
defineRule("failCertNo", (value, [failCertNoYn]) => {
  const failYn = JSON.parse(failCertNoYn);
  if (failYn && !value) {
    return "인증번호를 다시 입력해주세요.";
  } else {
    return true;
  }
});
defineRule("email", (value) => {
  const regex =
    /^([0-9a-zA-Z_.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/.test(value);
  if (regex) {
    return true;
  }
  return "올바른 이메일 형식을 입력해주세요.";
});
